import { GHAAccountType, GHAPropertyBrand } from '~/services/ConnectionGoogleService';

export const ACCOUNT_TYPE_ORDER: Array<GHAAccountType> = ['lpp', 'lpc', 'le_vacation_rental', 'scoopon'];

export const ACCOUNT_TYPE_LABELS: Record<GHAAccountType, string> = {
  lpp: 'LPP',
  scoopon: 'Scoopon',
  lpc: 'LPC',
  le_vacation_rental: 'LE Vacation Rental',
};

export const ACCOUNT_TYPES_BY_BRAND: Record<GHAPropertyBrand, Array<GHAAccountType>> = {
  luxuryescapes: ['lpp', 'lpc', 'le_vacation_rental'],
  scoopontravel: ['scoopon'],
};
